<!--<div style="font-size: 12px; margin-right: 3px; margin-bottom: 10px; border-radius: var(&#45;&#45;border-radius); overflow: hidden;"-->

<div class="ztdo-notes-container"
           [style.width]="width" [style.height]="height" data-cy="note-container">

  <div class="ztdo-notes-content" data-cy="note-content">
<!--    <textarea *ngIf="note" [disabled]="disabled" [(ngModel)]="note.Note" (appInputFinished)="onNoteInput($event)" [delayMs]="1000" style="line-height: 1.3; color: #888888; border: unset; height: fit-content;  overflow-y: auto;" [style.height]="height" [ngStyle]="{'background-color': isHideBorder ? 'unset' : '#F4F4F4'}"></textarea>-->

    <textarea *ngIf="note" [disabled]="disabled" [(ngModel)]="note.Note" (appInputFinished)="onNoteInput($event)"
              class="tdo-note-textarea"
              [delayMs]="1000"
              data-cy="note-textarea">
    </textarea>


  </div>
  <div class="ztdo-note-action-buttons" *ngIf="isActionButtonsOnRight==false" data-cy="note-action-buttons">
    <button mat-icon-button matTooltip="Note Builder" class="small-icon-button" (click)="openNoteBuilder(note)" data-cy="note-builder-button">
      <mat-icon data-cy="note-builder-icon">speaker_notes</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Macro Notes" class="small-icon-button" (click)="openMacroNotes(note)" data-cy="note-macro-button">
      <mat-icon data-cy="note-macro-icon">account_tree</mat-icon>
    </button>
  </div>
</div>
